var React = require('react');

function CookingTime (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"currentColor","d":"M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0m0 21.601c-5.294 0-9.601-4.307-9.601-9.601S6.706 2.399 12 2.399 21.601 6.706 21.601 12 17.294 21.601 12 21.601","key":0}),React.createElement("path",{"fill":"currentColor","d":"M13.2 4.238h-2.4v8.421l.85.542 6.068 3.87 1.29-2.024-5.809-3.703z","key":1})]);
}

CookingTime.defaultProps = {"width":"24","height":"24","fill":"none"};

module.exports = CookingTime;

CookingTime.default = CookingTime;
